module.exports = __webpack_public_path__ + "img/icon3.40bd2726.png";